angular.module('rjmNg.common.api').factory 'Session', [
  "$resource"
  "phpServiceUrl"
  (
    $resource
    phpServiceUrl
  ) ->

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actions =
      authorize: angular.extend {}, defaultParams,
        method: "POST"
        url: phpServiceUrl("/ims/authorize")
      createIMS: angular.extend {}, defaultParams,
        method: "POST"
        url: phpServiceUrl("/newSession/createIMS")
      create: angular.extend {}, defaultParams,
        method: "POST"
      createTemp: angular.extend {}, defaultParams,
        method: "POST"
        url: phpServiceUrl("/newSession/createTemp")
      destroy: angular.extend {}, defaultParams,
        method: "POST"
        url: phpServiceUrl("/newSession/destroy")

    session = $resource(phpServiceUrl("/newSession"), {}, actions)

    authorize: () ->
      session.authorize({}).$promise

    createIMS: (code, state) ->
      session.createIMS({code, state}).$promise

    create: (username, password, stayLoggedIn=false) ->
      session.create({username, password, stayLoggedIn}).$promise

    createTemp: (email, token) ->
      session.createTemp({email, token}).$promise

    destroy: () ->
      session.destroy({}).$promise

]
